import { BRAND, CONTACT } from "@/data/content";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0B111A] text-[#98A2B3]"
    >
      <div className="mx-auto max-w-7xl px-5 py-16 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center bg-[#FDB022] font-display text-lg font-black text-[#101828]">
                C
              </span>
              <div>
                <div className="font-display text-lg font-bold text-white">
                  {BRAND.name}
                </div>
                <div className="font-mono-accent">INDIA DESK · SINCE 2018</div>
              </div>
            </div>
            <p className="mt-6 max-w-md text-sm leading-relaxed">
              India's customs clearance and last-mile partner for international
              freight forwarders. Licensed CHA. 24/7 operations. Delhi NCR
              headquartered.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono-accent mb-4 text-[#FDB022]">SERVICES</p>
            <ul className="space-y-2 text-sm">
              <li><a href="#services" className="hover:text-white">Air Express Clearance</a></li>
              <li><a href="#services" className="hover:text-white">Last Mile India Delivery</a></li>
              <li><a href="#services" className="hover:text-white">Luggage & Baggage Clearance</a></li>
              <li><a href="#services" className="hover:text-white">Forwarder Partnership</a></li>
              <li><a href="/blog" className="hover:text-white">Blog & Insights</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono-accent mb-4 text-[#FDB022]">CONTACT</p>
            <ul className="space-y-3 text-sm">
              <li>
                <a href={CONTACT.telHref} className="hover:text-white" data-testid="footer-phone">
                  {CONTACT.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={CONTACT.emailHref} className="hover:text-white" data-testid="footer-email">
                  {CONTACT.email}
                </a>
              </li>
              <li className="text-[#98A2B3]">
                {CONTACT.address.line1}, {CONTACT.address.city},<br />
                {CONTACT.address.state} {CONTACT.address.pincode}, {CONTACT.address.country}
              </li>
            </ul>
            <p className="font-mono-accent mt-6 text-[#FDB022]">SERVICEABLE PORTS</p>
            <p className="mt-2 text-xs leading-relaxed">
              DEL · BOM · BLR · MAA · HYD · CCU · COK · Delivery to 19,000+ pincodes
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-[#1F2937] pt-6 text-xs md:flex-row md:items-center">
          <p>© {year} {BRAND.name}. All rights reserved.</p>
          <p className="font-mono-accent">customclearancepartner.in · .com</p>
        </div>
      </div>
    </footer>
  );
}
